import React from 'react';
import { getTeamName } from './TeamName';
import RenderPhoneNumberCell from 'components/Common/RenderPhoneNumber/RenderPhoneNumberCell';

export const formatFilterData = (data) =>
  Object.keys(data).map((key) => {
    if (key === 'nameSearchValue') {
      return { fieldName: 'name', type: 'Like', value: data[key] };
    }
    if (key === 'idSearchValue' && data[key] !== '') {
      return { fieldName: 'id', type: 'Equals', value: data[key] };
    }
    if (key === 'fqdnSearchValue') {
      return { fieldName: 'fullyQualifiedName', type: 'Like', value: data[key] };
    }

    return { fieldName: key, type: 'Like', value: data[key] };
  });

export const getTeamTableColumns = ({ t, classes }) => [
  {
    id: 1,
    title: t('team_name', 'Team Name'),
    field: 'name',
    sortable: true,
    ariaLabel: t('team_name', 'Team Name'),
    render: (_column, row) => getTeamName(row, classes),
  },
  {
    id: 2,
    title: t('team_id', 'Team ID'),
    field: 'id',
    sortable: true,
    ariaLabel: t('team_id', 'Team ID'),
    render: (_column, row) => row.data.id,
  },
  {
    id: 3,
    title: t('phone_number', 'Phone Number'),
    field: 'smsPhoneNumber',
    sortable: true,
    ariaLabel: t('phone_number', 'Phone Number'),
    render: (_column, row) =>
      row.data.smsPhoneNumber ? (
        <RenderPhoneNumberCell phoneNumber={row.data.smsPhoneNumber} t={t} />
      ) : (
        'N/A'
      ),
  },
];

export const getTeamRowData = (teams, t) =>
  teams.map((team) => ({
    id: team.id,
    data: {
      name: team.name,
      id: team.id,
      smsPhoneNumber: team.smsPhoneNumber,
    },
    activateAriaLabel: (row) =>
      t('teams-list:table.selectRowAriaLabel', 'Select {{name}}', {
        name: row.data.name,
      }),
  }));

export const tableHeadersList = [
  { name: 'Level1', index: 0, isSkipped: false },
  { name: 'Level2', index: 1, isSkipped: true },
  { name: 'Level3', index: 2, isSkipped: true },
];

export const sampleDataRows = [
  {
    level1: 'Team 1',
    level2: 'Team 1.1',
    level3: 'Team 1.2',
  },
  {
    level1: 'Team 2',
    level2: 'Team 2.1',
  },
  {
    level1: 'Team 3',
  },
];

/* dropdown options for file upload column remapping */
export const teamFields = [
  { name: 'Level1', displayName: 'Level1' },
  { name: 'Level2', displayName: 'Level2' },
  { name: 'Level3', displayName: 'Level3' },
  { name: 'Level4', displayName: 'Level4' },
  { name: 'Level5', displayName: 'Level5' },
  { name: 'Level6', displayName: 'Level6' },
  { name: 'Level7', displayName: 'Level7' },
  { name: 'Level8', displayName: 'Level8' },
  { name: 'Level9', displayName: 'Level9' },
  { name: 'Level10', displayName: 'Level10' },
];

export const formattedHeaders = (headers) =>
  headers.map(({ name, index }) => ({
    name: name.replace(/\s/g, ''),
    index,
  }));
